export default __webpack_public_path__ + "static/media/logo.cfbf5a9d.png";